module.exports = __webpack_public_path__ + "static/f-CGuillen-8ba8d7a9a5638f6c470506cc21938482.jpg";